<template>
  <v-app>
<!--    <v-app-bar-->
<!--      app-->
<!--      color="primary"-->
<!--      dark-->
<!--    >-->
<!--      <div class="d-flex align-center">-->
<!--        <v-img-->
<!--          alt="Vuetify Logo"-->
<!--          class="shrink mr-2"-->
<!--          contain-->
<!--          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"-->
<!--          transition="scale-transition"-->
<!--          width="40"-->
<!--        />-->

<!--        <v-img-->
<!--          alt="Vuetify Name"-->
<!--          class="shrink mt-1 hidden-sm-and-down"-->
<!--          contain-->
<!--          min-width="100"-->
<!--          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"-->
<!--          width="100"-->
<!--        />-->
<!--      </div>-->

<!--      <v-spacer></v-spacer>-->

<!--      <v-btn-->
<!--        href="https://github.com/vuetifyjs/vuetify/releases/latest"-->
<!--        target="_blank"-->
<!--        text-->
<!--      >-->
<!--        <span class="mr-2">Latest Release</span>-->
<!--        <v-icon>mdi-open-in-new</v-icon>-->
<!--      </v-btn>-->
<!--    </v-app-bar>-->

    <v-main>
        <router-view/>
    </v-main>
  </v-app>
</template>

<script>
// import Home from './views/Home';

export default {
  name: 'App',

  components: {
    // Home,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Medium.eot');
        src: local('SF Pro Display Medium'), local('SFProDisplay-Medium'),
        url('./assets/Fonts/SFProDisplay-Medium.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Medium.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Medium.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Medium.ttf') format('truetype');
        font-weight: 500;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Heavy.eot');
        src: local('SF Pro Display Heavy'), local('SFProDisplay-Heavy'),
        url('./assets/Fonts/SFProDisplay-Heavy.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Heavy.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Heavy.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Heavy.ttf') format('truetype');
        font-weight: 900;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-UltralightItalic.eot');
        src: local('SF Pro Display UltralightItalic'), local('SFProDisplay-UltralightItalic'),
        url('./assets/Fonts/SFProDisplay-UltralightItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-UltralightItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-UltralightItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-UltralightItalic.ttf') format('truetype');
        font-weight: 200;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-RegularItalic.eot');
        src: local('SF Pro Display Regular Italic'), local('SFProDisplay-RegularItalic'),
        url('./assets/Fonts/SFProDisplay-RegularItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-RegularItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-RegularItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-RegularItalic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Thin.eot');
        src: local('SF Pro Display Thin'), local('SFProDisplay-Thin'),
        url('./assets/Fonts/SFProDisplay-Thin.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Thin.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Thin.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Thin.ttf') format('truetype');
        font-weight: 100;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Light.eot');
        src: local('SF Pro Display Light'), local('SFProDisplay-Light'),
        url('./assets/Fonts/SFProDisplay-Light.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Light.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Light.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Light.ttf') format('truetype');
        font-weight: 200;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-BlackItalic.eot');
        src: local('SF Pro Display Black Italic'), local('SFProDisplay-BlackItalic'),
        url('./assets/Fonts/SFProDisplay-BlackItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-BlackItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-BlackItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-BlackItalic.ttf') format('truetype');
        font-weight: 900;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Bold.eot');
        src: local('SF Pro Display Bold'), local('SFProDisplay-Bold'),
        url('./assets/Fonts/SFProDisplay-Bold.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Bold.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Bold.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Bold.ttf') format('truetype');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Black.eot');
        src: local('SF Pro Display Black'), local('SFProDisplay-Black'),
        url('./assets/Fonts/SFProDisplay-Black.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Black.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Black.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Black.ttf') format('truetype');
        font-weight: 900;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-SemiboldItalic.eot');
        src: local('SF Pro Display SemiboldItalic'), local('SFProDisplay-SemiboldItalic'),
        url('./assets/Fonts/SFProDisplay-SemiboldItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-SemiboldItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-SemiboldItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-SemiboldItalic.ttf') format('truetype');
        font-weight: 600;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Ultralight.eot');
        src: local('SF Pro Display Ultralight'), local('SFProDisplay-Ultralight'),
        url('./assets/Fonts/SFProDisplay-Ultralight.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Ultralight.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Ultralight.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Ultralight.ttf') format('truetype');
        font-weight: 200;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-LightItalic.eot');
        src: local('SF Pro Display LightItalic'), local('SFProDisplay-LightItalic'),
        url('./assets/Fonts/SFProDisplay-LightItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-LightItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-LightItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-LightItalic.ttf') format('truetype');
        font-weight: 200;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-ThinItalic.eot');
        src: local('SF Pro Display ThinItalic'), local('SFProDisplay-ThinItalic'),
        url('./assets/Fonts/SFProDisplay-ThinItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-ThinItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-ThinItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-ThinItalic.ttf') format('truetype');
        font-weight: 100;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-MediumItalic.eot');
        src: local('SF Pro Display MediumItalic'), local('SFProDisplay-MediumItalic'),
        url('./assets/Fonts/SFProDisplay-MediumItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-MediumItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-MediumItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-MediumItalic.ttf') format('truetype');
        font-weight: 500;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Semibold.eot');
        src: local('SF Pro Display Semibold'), local('SFProDisplay-Semibold'),
        url('./assets/Fonts/SFProDisplay-Semibold.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Semibold.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Semibold.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Semibold.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-HeavyItalic.eot');
        src: local('SF Pro Display HeavyItalic'), local('SFProDisplay-HeavyItalic'),
        url('./assets/Fonts/SFProDisplay-HeavyItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-HeavyItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-HeavyItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-HeavyItalic.ttf') format('truetype');
        font-weight: 900;
        font-style: italic;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-Regular.eot');
        src: local('SF Pro Display Regular'), local('SFProDisplay-Regular'),
        url('./assets/Fonts/SFProDisplay-Regular.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-Regular.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-Regular.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'SF Pro Display';
        src: url('./assets/Fonts/SFProDisplay-BoldItalic.eot');
        src: local('SF Pro Display BoldItalic'), local('SFProDisplay-BoldItalic'),
        url('./assets/Fonts/SFProDisplay-BoldItalic.eot?#iefix') format('embedded-opentype'),
        url('./assets/Fonts/SFProDisplay-BoldItalic.woff2') format('woff2'),
        url('./assets/Fonts/SFProDisplay-BoldItalic.woff') format('woff'),
        url('./assets/Fonts/SFProDisplay-BoldItalic.ttf') format('truetype');
        font-weight: bold;
        font-style: italic;
    }



</style>
